module.exports = __webpack_public_path__ + "static/001-6642073017f2cabfec7b39dedb54702c.jpg";